"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
  var className = _ref.className,
      colorIcon = _ref.colorIcon,
      cursor = _ref.cursor,
      disabled = _ref.disabled,
      fontSizeLabel = _ref.fontSizeLabel,
      icon = _ref.icon,
      iconRight = _ref.iconRight,
      label = _ref.label,
      onClick = _ref.onClick,
      placement = _ref.placement,
      popoverOverData = _ref.popoverOverData,
      popoverWidth = _ref.popoverWidth,
      sizeIcon = _ref.sizeIcon,
      styleContent = _ref.styleContent,
      tooltipText = _ref.tooltipText,
      type = _ref.type,
      variant = _ref.variant,
      widthButton = _ref.widthButton;
  var Icon = icon;
  var colours = {
    primary: '#0063bd',
    secondary: '#d4cfcf',
    success: '#4ad295',
    info: '#159ad8',
    danger: '#ff6666',
    warning: '#ff973d',
    dark: '#575757'
  };
  var color = colours[colorIcon] || null;
  var tooltip = placement && tooltipText ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, {
    id: "tooltip-".concat(placement)
  }, tooltipText) : null;
  var popover = placement && popoverOverData.length ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
    id: "popover-basic",
    style: {
      maxWidth: popoverWidth
    },
    className: "bs-popover-".concat(placement)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover.Body, {
    bsPrefix: "popover-body",
    style: {
      width: popoverWidth
    }
  }, popoverOverData.map(function (el) {
    return /*#__PURE__*/_react.default.createElement("h6", {
      className: "popoverText",
      key: el
    }, el);
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    key: placement,
    placement: placement,
    overlay: tooltip || popover
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    type: type,
    variant: variant,
    onClick: onClick,
    disabled: disabled,
    style: {
      fontSize: '13px',
      padding: '9px 0',
      width: widthButton,
      fontWeight: '600',
      cursor: cursor
    },
    className: className
  }, icon && label && iconRight && /*#__PURE__*/_react.default.createElement("div", {
    className: "style-content-text-icon ".concat(styleContent)
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontSize: fontSizeLabel
    }
  }, label), /*#__PURE__*/_react.default.createElement(Icon, {
    style: {
      fontSize: sizeIcon,
      marginLeft: '12px',
      color: colorIcon ? color : undefined
    }
  })), icon && label && !iconRight && /*#__PURE__*/_react.default.createElement("div", {
    className: "style-content-text-icon ".concat(styleContent)
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    style: {
      fontSize: sizeIcon,
      marginRight: '10px',
      color: colorIcon ? color : undefined
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontSize: fontSizeLabel
    }
  }, label)), label === '' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Icon, {
    style: {
      fontSize: sizeIcon,
      color: color
    }
  })), icon === '' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label)));
};

var _default = Button;
exports.default = _default;
Button.propTypes = {
  type: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  icon: _propTypes.default.any,
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'info', 'success', 'warning', 'danger', 'dark', 'light', 'light-gray', 'white', 'link', 'outline-primary', 'outline-secondary', 'outline-info', 'outline-success', 'outline-warning', 'outline-danger', 'outline-dark', 'filter-yellow', 'filter-orange', 'filter-light-red', 'filter-dark-red', 'filter-green', 'filter-blue', 'filter-violet', 'filter-black', 'filter-outline-yellow', 'filter-outline-orange', 'filter-outline-light-red', 'filter-outline-dark-red', 'filter-outline-green', 'filter-outline-blue', 'filter-outline-violet', 'filter-outline-black']),
  colorIcon: _propTypes.default.oneOf(['info', 'primary', 'secondary', 'success', 'dark', 'warning', 'danger', 'light']),
  sizeIcon: _propTypes.default.string,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  widthButton: _propTypes.default.string,
  iconRight: _propTypes.default.bool,
  styleContent: _propTypes.default.string,
  fontSizeLabel: _propTypes.default.string,
  placement: _propTypes.default.string,
  tooltipText: _propTypes.default.string,
  popoverOverData: _propTypes.default.arrayOf(_propTypes.default.string),
  popoverWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  className: _propTypes.default.string,
  cursor: _propTypes.default.oneOf(['all-scroll', 'auto', 'col-resize', 'crosshair', 'default', 'e-resize', 'hand', 'help', 'move', 'n-resize', 'ne-resize', 'no-drop', 'not-allowed', 'nw-resize', 'pointer', 'progress', 'row-resize', 's-resize', 'se-resize', 'sw-resize', 'text', 'vertical-text', 'w-resize', 'wait'])
};
Button.defaultProps = {
  className: '',
  cursor: 'pointer',
  disabled: false,
  fontSizeLabel: '',
  icon: '',
  iconRight: false,
  label: '',
  onClick: function onClick() {},
  placement: '',
  popoverOverData: [],
  popoverWidth: '120px',
  sizeIcon: '18px',
  styleContent: '',
  tooltipText: '',
  variant: 'light',
  widthButton: '120px'
};